import { api } from "./client";
import type {
  Leak,
  DataType,
  ReviewStatus,
  LeakListResponse,
  LeakQueryParams,
} from "../types/leak";

/* Re-export types for backward-compatible imports */
export type { Leak, DataType, ReviewStatus, LeakListResponse, LeakQueryParams };

/* =========================
   API Calls
   ========================= */

export async function fetchLeaks(
  params: LeakQueryParams
): Promise<LeakListResponse> {
  const res = await api.get("/leaks/", { params });
  return res.data;
}

export async function fetchSectors(): Promise<string[]> {
  const res = await api.get("/leaks/sectors");
  return res.data;
}

export async function fetchLeakById(id: string, params?: { search?: string }): Promise<Leak> {
  const res = await api.get(`/leaks/${id}`, { params });
  return res.data;
}

export async function updateLeakReview(
  id: string,
  payload: {
    review_status?: ReviewStatus;
    analyst_notes?: string;
    client_notified?: boolean;
  }
) {
  const res = await api.patch(`/leaks/${id}/review`, payload);
  return res.data;
}

export async function fetchReviewHistory(id: string) {
  const res = await api.get(`/leaks/${id}/review-history`);
  return res.data as { event: string; timestamp: string }[];
}

export async function fetchCategories(params: any) {
  const res = await api.get("/leaks/categories", { params });
  return res.data;
}

export async function fetchSources(params: any) {
  const res = await api.get("/leaks/sources", { params });
  return res.data;
}

export async function fetchTargets(type: string, search: string = "", signal?: AbortSignal) {
  const params = { type, ...(search ? { search } : {}) };
  const res = await api.get("/leaks/targets", { params, signal });
  return res.data;
}

export async function fetchFacets(facet: string, filters: any) {
  const res = await api.get("/leaks/facets", { params: { facet, ...filters } });
  return res.data;
}

export async function savePost(id: string) {
  const res = await api.post(`/leaks/saved/${id}`);
  return res.data;
}

export async function unsavePost(id: string) {
  const res = await api.delete(`/leaks/saved/${id}`);
  return res.data;
}

export async function fetchSavedPosts() {
  const res = await api.get("/leaks/saved");
  return res.data;
}

export async function createExport(scope: string, params: any) {
  const res = await api.post("/leaks/exports", null, { params: { scope, ...params } });
  return res.data;
}

export async function fetchExports() {
  const res = await api.get("/leaks/exports");
  return res.data;
}

export async function deleteExport(id: string) {
  const res = await api.delete(`/leaks/exports/${id}`);
  return res.data;
}
